package com.partejar.app.feature.calendar

import androidx.compose.runtime.Composable

enum class CalendarPermissionStatus {
    NOT_DETERMINED,
    GRANTED,
    DENIED,
    BLOCKED,
    RESTRICTED,
    UNAVAILABLE
}

data class CalendarEventDraft(
    val title: String,
    val startsAtEpochMillis: Long,
    val endsAtEpochMillis: Long,
    val location: String? = null,
    val description: String? = null,
    val sourceKey: String? = null
)

enum class CalendarEventOpenResult {
    OPENED,
    PERMISSION_DENIED,
    UNAVAILABLE,
    FAILED
}

enum class CalendarEventSaveStatus { SAVED, PERMISSION_DENIED, UNAVAILABLE, FAILED }

data class CalendarEventSaveResult(val status: CalendarEventSaveStatus, val eventId: String? = null)

interface CalendarIntegration {
    suspend fun getPermissionStatus(): CalendarPermissionStatus
    suspend fun requestPermission(): CalendarPermissionStatus
    suspend fun openEventEditor(event: CalendarEventDraft): CalendarEventOpenResult
    suspend fun saveEvent(event: CalendarEventDraft, existingEventId: String?): CalendarEventSaveResult =
        CalendarEventSaveResult(CalendarEventSaveStatus.UNAVAILABLE)
    fun openSystemSettings()
}

@Composable
expect fun rememberCalendarIntegration(): CalendarIntegration
